/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export const RoleEnum = {
    AuthenticatedUser: 'authenticated-user',
    PaymentAuthoriser: 'payment-authoriser',
    PaymentPreparer: 'payment-preparer',
    CustomerSupportUser: 'customer-support-user',
    CustomerSupportSupervisor: 'customer-support-supervisor',
    SystemAdmin: 'system-admin',
    SystemProcess: 'system-process',
    WorkspaceAdmin: 'workspace-admin',
    WorkspaceOwner: 'workspace-owner',
    WorkspaceUser: 'workspace-user',
};
